import _ from 'lodash'

export function combineYear(value, sign) {
  if (!_.isNumber(value)) {
    return null
  }

  return value * (sign ? -1 : 1)
}
